module.exports = __webpack_public_path__ + "static/media/sample7.f7b40cb4.jpg";